package com.iptvplayer.web.ui

import org.koin.core.context.GlobalContext

/** Resolve a dependency (e.g. a ViewModel registered as `factory`) from Koin. */
inline fun <reified T : Any> koinGet(): T = GlobalContext.get().get()
